
import {CloudProvisionerTemplateRequestIonos, CloudProvisionerTemplateRequestOvh, GlobalResponse } from '~/models/Commons ';
import { api } from '../api';
import { CLOUD_PROVISIONER } from '../endpoints';
import { SET_CLOUDPROVISIONER } from '~/store/Provisioner';
import { getHeaders } from '../generics/Header';

const extendedApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getCloudProvisioner: builder.query<GlobalResponse<any>, number>({
      query: (id) => ({
        url: `${CLOUD_PROVISIONER}/${id}/componentLimits`,
        method: 'GET',
        credentials: 'include',
        headers: getHeaders()
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(SET_CLOUDPROVISIONER(data.payload));
        } catch (error) {
          console.error('Error fetching cloud provisioner:', error);
        }
      },
    }),
 addCloudProvisionerTemplateOvh: builder.mutation<GlobalResponse<CloudProvisionerTemplateRequestOvh>, CloudProvisionerTemplateRequestOvh>({
      query: data => {
        const formData = new FormData();
        const cloudProvisionerRequestBlob = new Blob(
          [
            JSON.stringify({
              fileName: data.fileName,
              os: data.os,
              providerType:data.providerType,
              projectId:data.projectId,
              region:data.region,
              flavor:data.flavor

            }),
          ],
          { type: 'application/json' }
        );
        formData.append('cloudProvisionerTemplateRequest', cloudProvisionerRequestBlob, 'cloudProvisionerTemplateRequest.json');

        // Add main  file if available
        if (data.file) {
          formData.append('file', data.file);
        }
        return {
          url: CLOUD_PROVISIONER,
          method: 'POST',
          body: formData,
          formData: true,
          credentials: 'include',
          headers:getHeaders()
        };
      },
    }),
     addCloudProvisionerTemplateIonos: builder.mutation<GlobalResponse<CloudProvisionerTemplateRequestIonos>, CloudProvisionerTemplateRequestIonos>({
      query: data => {
        const formData = new FormData();
        const cloudProvisionerRequestBlob = new Blob(
          [
            JSON.stringify({
              fileName: data.fileName,
              os: data.os,
              providerType:data.providerType,
              maxCpuCore:data.maxCpuCore,
              minCpuCore:data.minCpuCore,
              maxRam:data.maxRam,
              minRam:data.minRam,
              maxStorage:data.maxStorage,
              minStorage:data.minStorage,
            }),
          ],
          { type: 'application/json' }
        );
        formData.append('cloudProvisionerTemplateRequest', cloudProvisionerRequestBlob, 'cloudProvisionerTemplateRequest.json');

        // Add main  file if available
        if (data.file) {
          formData.append('file', data.file);
        }
        return {
          url: CLOUD_PROVISIONER,
          method: 'POST',
          body: formData,
          formData: true,
          credentials: 'include',
          headers:getHeaders()
        }
      }
    }),
    getCloudProvisionerFull: builder.query<GlobalResponse<any[]>, void>({
      query: () => ({
        url: CLOUD_PROVISIONER,
        method: 'GET',
        credentials: 'include',
        headers: getHeaders()
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(SET_CLOUDPROVISIONER(data.payload));
        } catch (error) {
          console.error('Error fetching full cloud provisioner list:', error);
        }
      },
    }),
   getCloudProvisionerListWithPagination: builder.query<
  GlobalResponse<any[]>,
  { page: number; size: number;}
>({
  query: ({ page, size}) => ({
    url: `${CLOUD_PROVISIONER}?page=${page}&size=${size}`,
    method: 'GET',
    credentials: 'include',
    headers: getHeaders(),
  }),

  async onQueryStarted(_, { dispatch, queryFulfilled }) {
    try {
      const { data } = await queryFulfilled;
      dispatch(SET_CLOUDPROVISIONER(data.payload));
    } catch (error) {
      console.error('Error fetching full cloud provisioner list:', error);
    }
  },
})
  }),
});

export const {
  useGetCloudProvisionerQuery,
  useLazyGetCloudProvisionerQuery,
  useGetCloudProvisionerFullQuery,
  useGetCloudProvisionerListWithPaginationQuery,
  useLazyGetCloudProvisionerFullQuery,
  useAddCloudProvisionerTemplateOvhMutation,
  useAddCloudProvisionerTemplateIonosMutation
} = extendedApiSlice;
